import { AuxTooltip } from "@blk/aladdin-react-components-es";
import React from "react";
import "./clickthroughLinkOverride.scss";
import { openOnce } from "./utils";
import { useGetDatapointsMetadata } from "api/ux/src";
import { appInsightEvents } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { getCurrentLocalTime } from "common/date-utils";
export const ClickthroughLinkOverride = (props) => {
    const [meta] = useGetDatapointsMetadata();
    const metadatapoint = meta.find((a) => a.id === props.datapointTarget)?.metadata;
    const path = metadatapoint?.path;
    const scopeObjectId = path && Array.isArray(path) && path.length > 1 && path[0] === "Fund" ? props.fundMasterId : props.assetMasterId;
    const params = new URLSearchParams({
        datapointTarget: metadatapoint?.baseDataPointId?.toString() ?? "",
        documentId: props.documentId,
        scopeMasterId: scopeObjectId
    }).toString();
    return React.createElement("span", null,
        React.createElement(AuxTooltip, null,
            React.createElement("a", { slot: "target", className: "linkInspectData", onClick: () => {
                    appInsightsTrackEvent({
                        name: appInsightEvents.customEvents.names.ClickthroughLinkClicked,
                        properties: { LocalTimestamp: getCurrentLocalTime(), documentId: props.documentId }
                    });
                    const exsistingWindow = openOnce(`/clickthrough?${params}`, props.documentId);
                    const message = {
                        dataPointTarget: metadatapoint?.baseDataPointId?.toString() ?? "",
                        scopeMasterId: scopeObjectId
                    };
                    exsistingWindow?.postMessage(message);
                } }, props.defaultRendererContent),
            React.createElement("div", { slot: "content" }, "Open source document to view details")));
};
